// extracted by mini-css-extract-plugin
export default {"tx":"_7fb350d734","line":"_9219cef583"};